import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/homepage' },
    { name: 'About Us', path: '/about' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    { name: 'Position Print Fabric', path: '/portfolio' },
    { name: 'Polyester Fabric', path: '/portfolio' },
    { name: 'Natural Crepe', path: '/portfolio' },
    { name: 'Velvet Embroidery', path: '/portfolio' },
    { name: 'Chinon & Shimmer', path: '/portfolio' }
  ];

  const contactInfo = [
    {
      icon: 'MapPin',
      title: 'Factory Address',
      details: ['123 Textile Hub, Industrial Area', 'Ahmedabad, Gujarat 380015', 'India']
    },
    {
      icon: 'Phone',
      title: 'Phone Numbers',
      details: ['+91 98765 43210', '+91 79 2345 6789']
    },
    {
      icon: 'Mail',
      title: 'Email Address',
      details: ['info@kunjvihari.com', 'sales@kunjvihari.com']
    }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: 'Facebook', url: '#' },
    { name: 'Instagram', icon: 'Instagram', url: '#' },
    { name: 'LinkedIn', icon: 'Linkedin', url: '#' },
    { name: 'Twitter', icon: 'Twitter', url: '#' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleNewsletterSubmit = (e) => {
    e?.preventDefault();
    alert('Thank you for subscribing to our newsletter!');
  };

  return (
    <footer className="bg-white text-gray-900 py-6 sm:py-8 lg:py-12 border-t-2 border-primary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-4 sm:mb-6 lg:mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-3 sm:mb-4 lg:mb-6">
              <img 
                src="/assets/images/logo.png" 
                alt="Kunjvihari Impex" 
                className="h-[120px] sm:h-[136px] lg:h-[152px] w-auto" 
              />
            </div>
            <p className="text-xs sm:text-sm text-gray-600">
              <span className="font-semibold">GST:</span> 24ABCDE1234F1Z5
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
              Quick Links
            </h3>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigation('/homepage')}
                  className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/about')}
                  className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/portfolio')}
                  className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('/contact')}
                  className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Our Fabrics */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
              Our Fabrics
            </h3>
            <ul className="space-y-1.5 sm:space-y-2">
              {services?.map((service, index) => (
                <li key={index}>
                  <button 
                    onClick={() => handleNavigation(service?.path)}
                    className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium"
                  >
                    {service?.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
              Contact Us
            </h3>
            <div className="space-y-1.5 sm:space-y-2 lg:space-y-3">
              <div className="flex items-start space-x-2">
                <Icon name="MapPin" size={14} className="text-primary mt-0.5 flex-shrink-0 sm:w-4 sm:h-4" />
                <span className="text-[10px] sm:text-xs lg:text-sm text-gray-600 leading-relaxed">
                  115, 116 Shree Darshan Industry Estate, Near Amrut Udhyog Nagar, Kamrej Road, Surat - 395010, Gujarat
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Phone" size={14} className="text-primary flex-shrink-0 sm:w-4 sm:h-4" />
                <a 
                  href="tel:+919974056700" 
                  className="text-xs sm:text-sm text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  +91 99740 56700
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Mail" size={14} className="text-primary flex-shrink-0 sm:w-4 sm:h-4" />
                <a 
                  href="mailto:info@kunjvihariimpex.com" 
                  className="text-xs sm:text-sm text-gray-600 hover:text-primary transition-colors font-medium"
                >
                  info@kunjvihariimpex.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-4 sm:pt-6 lg:pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 sm:gap-4">
            <p className="text-[10px] sm:text-xs lg:text-sm text-gray-500 text-center md:text-left">
              &copy; {currentYear} Kunjvihari Impex. All rights reserved.
            </p>
            <p className="text-[10px] sm:text-xs lg:text-sm text-gray-500 font-medium">
              Precision in Every Thread
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;